import { makeStyles } from '@material-ui/core/styles'

export const useSettingsPageStyles = makeStyles(
  (theme) => ({
    pageContainer: {
      margin: '0 40px 20px 0px'
    },
    wrapper: {
      flexBasis: '555px'
    },
    fullWidth: {
      width: 'calc(100vw - 300px)'
    },
    root: {
      padding: 15
    },
    settingsTopic: {
      borderRadius: 12,
      padding: 15,
      width: '100%'
    },
    label: {
      '&, &.MuiFormLabel-root': {
        fontSize: '12px',
        fontWeight: 400,
        lineHeight: '14.4px',
        textAlign: 'left',
        marginBottom: 15
      }
    },
    input: {
      fontSize: '12px',
      fontWeight: 400,
      lineHeight: '14.4px !important',
      textAlign: 'left'
    },
    dash: {
      color: '#3987CF',
      marginRight: 3
    },
    star: {
      color: '#3987CF',
      marginLeft: 2
    },
    header: {
      fontSize: '18px',
      fontWeight: 600,
      lineHeight: '21.6px',
      textAlign: 'left',
      marginBottom: 32,
      marginTop: 10,
      textTransform: 'uppercase'
    },
    headerMapPanel: {
      fontSize: 18,
      fontWeight: 600,
      color: '#000',
      padding: 5,
      lineHeight: '21.6px',
      margin: '10px 10px 30px 10px'
    },
    workflow: {
      '& span': {
        color: '#1F364D',
        fontSize: '12px',
        fontWeight: 400,
        lineHeight: '14.4px',
        textAlign: 'left'
      },
      '& .Mui-disabled span': {
        color: `${theme.palette.mpSkladPrimary.gray} !important`
      },
      '& span:not(.Mui-disabled)': {
        color: '#3987CF'
      }
    },
    workflowLabel: {
      color: '#1F364D !important'
    },
    saveButton: {
      width: 160,
      height: 40,
      color: '#FFFFFF',
      alignItems: 'center'
    },
    helperText: {
      fontSize: 11,
      fontWeight: 400,
      marginTop: 10
    },
    boldLabel: {
      '&.MuiFormLabel-root': {
        fontSize: 12,
        marginBottom: 12,
        fontWeight: 600,
        color: '#1F364D'
      }
    },
    unifiedPricesLabel: {
      '&.MuiFormLabel-root': {
        fontSize: '12px',
        fontWeight: 600,
        lineHeight: '14.4px',
        textAlign: 'left',
        color: '#1F364D'
      }
    },
    supplySettingsContainer: {
      flexWrap: 'unset',
      marginTop: 20,
      marginBottom: 20,
      marginLeft: 0,
      padding: 20,
      borderRadius: 12,
      width: 'calc(100% - 40px)'
    },
    link: {
      color: '#3987CF'
    },
    hintsContainer: {
      position: 'absolute',
      right: 50
    },
    helpActionsBox: {
      padding: 20,
      width: 'fit-content',
      backgroundColor: '#FBFBFD',
      height: 'fit-content'
    },
    helpBox: {
      padding: 20,
      minWidth: 200,
      maxWidth: 400,
      backgroundColor: '#FBFBFD',
      height: 'fit-content',
      marginBottom: 40
    },
    helpBoxLabel: {
      '&.MuiFormLabel-root': {
        marginBottom: 20,
        fontWeight: 'bold',
        fontSize: 14,
        color: '#F19F94'
      }
    },
    helperIcon: {
      marginLeft: 4,
      padding: 2,
      verticalAlign: 'middle'
    }
  })
)